module.exports = __webpack_public_path__ + "static/media/gas_02.47d7e477.svg";